import { request } from '@/common';
import { shuffle } from 'lodash-es';
import { makeAutoObservable, runInAction } from 'mobx';
import chatStoreManager from '@/store/chat/manager';
import { HelperCore } from "@/common/helper";
import userStore from '@/store/user';
import client from '@/store/client';
import sleep from "@shared/utils/sleep";

class Store {
  cloudConfig = {
    welcomeMessage: '我能帮你做些什么？',
    recommendMessages: [],
    hotWords: [],
    feedbackReasons: [],
  };

  hasNoChat = true;
  
  currentId = null;
  currentStore = null;

  constructor () {
    makeAutoObservable(this);

    if(!HelperCore.IS_PROD){
      window._wsStore = this;
    }
  }

  setCurrentId = (currentId) => {
    this.currentId = currentId;
  }

  loadCloudConfig = () => {
    request.get('/config/cloud', {
      params: {
        key: ['assistant_home_market_weishi', 'assistant_urm_reason'].join(','),
      },
    })
    .then(res => {
      const { data = {}, code } = res;
      const {
        map: { home_title = this.cloudConfig.welcomeMessage } = {},
        list: recommendMessages = [],
      } = data['assistant_home_market_weishi'] || {};
      runInAction(() => {
        this.updateCloudConfig({
          welcomeMessage: home_title,
          recommendMessages,
          feedbackReasons: data['assistant_urm_reason']?.list || [],
        });
      });
    });
  };

  getHotWord = () => {
    request.get('/hot/view/words', {
      params: {},
    })
    .then(res => {
      const { data = {} } = res;
      runInAction(() => {
        // 随机取3条数据
        if(data?.list) {
          let temp = shuffle(data.list);
          this.updateCloudConfig({
            hotWords : temp.slice(0,3),
          });
        }
      });
    });
  };

  loadLastChat = () => {
    this.hasNoChat = true;

    request.get('/assistant/conversation/info', {
      notReport : true,
    })
    .then(res => {
      const { code, data } = res;
      if(code == 0 && data?.messages?.length){
        // debug
        // 总结页面
        // data.conversation_id = "acd2cc748c6949259c05286d6dc7adba";
        // 丢消息？
        // data.conversation_id = "58422a922c8e421e8dfaf4f8e04d1c6a";
        const urlParams = HelperCore.getParams();
        if(urlParams.debug == "test_cid" && urlParams.k){
          data.conversation_id = urlParams.k;
        }

        const { conversation_id = "" } = data;
        runInAction(() => {
          this.setCurrentId(conversation_id);
          this.currentStore = chatStoreManager.newChatStore({ id : conversation_id });
          setTimeout(() => {
            runInAction(() => {
              this.hasNoChat = false;
            });
          }, 500);
        })
      }
      else {
        runInAction(() => {
          this.newChat();
        })
      }
    })
    .catch(() => {
      runInAction(() => {
        this.newChat();
      });
    });
  }
  checkHasNoChat = async () => {
    this.hasNoChat = true;

    return request.get('/assistant/conversation/info', {
      notReport : true,
    })
    .then(res => {
      const { code, data } = res;
      if(code == 0 && data?.messages?.length){
        runInAction(() => {
          this.hasNoChat = false;
        });
      }
    })
    .catch(() => {});
  }

  updateCloudConfig (config) {
    this.cloudConfig = {
      ...this.cloudConfig,
      ...config,
    }
  }

  // 右下角新会话
  newChat = async () => {
    // debug
    // HelperCore.log(`新会话 点击`);

    let lastAsstId = null;
    if(this.currentStore){
      lastAsstId = this.currentStore.currAsstId;
      if(this.currentStore.isAITyping){
        // 可中断
        if(this.currentStore.canAborting){
          // debug
          // HelperCore.log(`新会话 终止`);
          await this.currentStore.abort();
        }
        // 不可中断
        else {
          return;
        }
      }

      if(!this.currentStore.messageMap.size){
        return;
      }
    }
    // debug
    // HelperCore.log(`新会话 新 store`);
    runInAction(() => {
      this.currentStore = chatStoreManager.newChatStore();
      this.setCurrentId(null);
      try{
        if(!this.currentStore.currAsstId && lastAsstId){
          this.currentStore.setCurrAsstId(lastAsstId);
        }
      } catch(e){};
    });
    await sleep(300);
    this.checkHasNoChat();
  }

  sendMessage(params) {
    if(this.currentStore.currAsstId){
      this.currentStore.sendMessage(params);
    }
    else {
      const lastMessage = this.currentStore.lastMessage;
      this.currentStore.sendMessage({ asstId: lastMessage.role_id, ...params })
    }
  }

  doWhenLogin = (cb) => {
    if(userStore.isUser){
      cb();
      return;
    }
    client.run("ShowLogin");
  }
}

const wsStore = new Store();
export default wsStore;